import {
    PIPE_LOADING,
    PIPE_LOADED,
    PIPE_DETAILS,
    PIPE_EDITED,
    PIPE_CREATED,
    PIPE_DELETED,
    PIPE_EVENTS,
    PIPE_FAILED,
    PIPE_SEARCHED,
    PIPEACTIVITY_LOADING,
    PIPEACTIVITY_LOADED,
    PIPEACTIVITY_FAILED,
    DOMAIN_LOADING,
    DOMAIN_LOADED,
    DOMAIN_FAILED,
    DOMAIN_DELETED,
    DOMAIN_EDITED,
    DOMAIN_CREATETD,
    PIPEGROUP_LOADING,
    PIPEGROUP_FAILED,
    PIPEGROUP_DELETED,
    PIPEGROUP_EDITED,
    PIPEGROUP_CREATETD,
    PIPEGROUP_LOADED,
    PREFIXROUTE_LOADING,
    PREFIXROUTE_LOADED,
    PREFIXROUTE_FAILED,
    PREFIXROUTE_DELETED,
    PREFIXROUTE_EDITED,
    PREFIXROUTE_CREATETD,
    PREFIXROUTEGROUP_LOADING,
    PREFIXROUTEGROUP_LOADED,
    PREFIXROUTEGROUP_FAILED,
    PREFIXROUTEGROUP_DELETED,
    PREFIXROUTEGROUP_EDITED,
    PREFIXROUTEGROUP_CREATETD,
    LOGOUT,
} from '../types';

import {
    created,
    editedUpdate,
    editPaginated,
    createPaginated,
    deletePaginated,
    deleteFromState,
} from '../../helpers/reduxUtils';

const initialState = {
    searchResults: null,
    loading: false,
    allPipes: null,
    success: false,
    pipe: null,
    events: [],
    domains: [],
    activities: [],
    prefixRoutes: [],
    groups: [],
    routegrp: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PIPE_LOADING:
        case DOMAIN_LOADING:
        case PIPEGROUP_LOADING:
        case PREFIXROUTE_LOADING:
        case PIPEACTIVITY_LOADING:
        case PREFIXROUTEGROUP_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
            };
        case PIPE_EVENTS:
            return {
                ...state,
                loading: false,
                events: action.payload,
            };
        case PREFIXROUTEGROUP_LOADED:
            return {
                ...state,
                loading: false,
                routegrp: action.payload,
            };
        case PIPE_LOADED:
            return {
                ...state,
                pipe: null,
                loading: false,
                success: false,
                activities: [],
                searchResults: null,
                allPipes: action.payload,
            };
        case PREFIXROUTE_LOADED:
            return {
                ...state,
                loading: false,
                prefixRoutes: action.payload,
            };
        case DOMAIN_LOADED:
            return {
                ...state,
                loading: false,
                domains: action.payload,
            };
        case PIPEGROUP_LOADED:
            return {
                ...state,
                loading: false,
                groups: action.payload,
            };
        case PIPE_DETAILS:
            return {
                ...state,
                loading: false,
                success: false,
                activities: [],
                pipe: action.payload,
            };
        case DOMAIN_EDITED:
            return {
                ...state,
                loading: false,
                domains: editedUpdate(state.domains, action.payload, null, 'instno'),
            };
        case PREFIXROUTEGROUP_EDITED:
            return {
                ...state,
                loading: false,
                routegrp: editedUpdate(state.routegrp, action.payload),
            };
        case PREFIXROUTE_EDITED:
            return {
                ...state,
                loading: false,
                prefixRoutes: editedUpdate(state.prefixRoutes, action.payload),
            };
        case PIPE_EDITED:
            return {
                ...state,
                loading: false,
                success: true,
                // allPipes: editPaginated(state.allPipes, action.payload),
            };
        case PREFIXROUTE_DELETED:
            return {
                ...state,
                loading: false,
                prefixRoutes: deleteFromState(state.prefixRoutes, action.payload),
            };
        case DOMAIN_DELETED:
            return {
                ...state,
                loading: false,
                domains: deleteFromState(state.domains, action.payload, null, 'instno'),
            };
        case DOMAIN_CREATETD:
            return {
                ...state,
                loading: false,
                domains: created(state.domains, action.payload),
            };
        case PREFIXROUTE_CREATETD:
            return {
                ...state,
                loading: false,
                prefixRoutes: created(state.prefixRoutes, action.payload),
            };
        case PREFIXROUTEGROUP_CREATETD:
            return {
                ...state,
                loading: false,
                routegrp: created(state.routegrp, action.payload),
            };
        case PIPE_CREATED:
            return {
                ...state,
                loading: false,
                success: true,
                allPipes: createPaginated(state.allPipes, action.payload),
            };

        case PREFIXROUTEGROUP_DELETED:
            return {
                ...state,
                loading: false,
                routegrp: deleteFromState(state.routegrp, action.payload),
            };

        case PIPEGROUP_EDITED:
        case PIPEGROUP_DELETED:
        case PIPEGROUP_CREATETD:
            return {
                ...state,
                success: true,
                loading: false,
                pipe: action.payload,
                allPipes: editPaginated(state.allPipes, action.payload),
            };
        case PIPE_DELETED:
            return {
                ...state,
                loading: false,
                allPipes: deletePaginated(state.allPipes, action.payload),
            };
        case PIPE_SEARCHED:
            return {
                ...state,
                loading: false,
                searchResults: action.payload,
            };
        case PIPEACTIVITY_LOADED:
            return {
                ...state,
                loading: false,
                activities: action.payload,
            };
        case PREFIXROUTEGROUP_FAILED:
        case PIPEACTIVITY_FAILED:
        case PREFIXROUTE_FAILED:
        case PIPEGROUP_FAILED:
        case DOMAIN_FAILED:
        case PIPE_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            return {
                loading: false,
                allMnos: null,
                mno: null,
                searchResults: null,
                success: false,
            };
        default:
            return state;
    }
}